module.exports = {
  buildVersion: "0.1.1",
  buildDate: 1729158552102,
}